<template>
    <BaseModal name="confirmedIssueCarReturn" width="420" :clickToClose="false" :shiftY="0.5" @before-close="closeModal"
        @before-open="openModal" :adaptive="true" height="auto" classes="bg-transparent shadow-none">
        <div
            class="modal-base-content modal-content py-20 h-100 px-30 rounded-25 bg-white position-relative overflow-hidden">
            <BaseLoader v-if="localLoading"></BaseLoader>
            <div class="d-flex justify-content-end">
                <slot name="modal-header"></slot>
                <button type="button" class="btn-close" @click="$modal.hide('confirmedIssueCarReturn')"></button>
            </div>
            <div
                class="modal-content-dynamic flex-grow-1 d-flex flex-column h-100 align-items-center justify-content-center">
                <p class="fw-bold mb-15 text-center">
                    {{ dataLang['reg_contract_modal_25'] }}
                </p>

                <p class="text-center fsc-14">
                    {{ dataLang['reg_contract_modal_10'] }}
                </p>
                <div class="d-flex gap-5 mb-10 wp-100">
                    <BaseDatePicker v-model="dateTime" time-title-format="DD.MM.YYYY" :disabled-date="notAfterToday"
                        :disabled-time="notAfterToday" :clearable="false" type="datetime"
                        class="fsc-11 wp-100 text-center idiots-class-for-input-date" lang="ru"
                        :format="`${userSetting.company__tempalte_date} HH:mm`">
                    </BaseDatePicker>
                </div>
                <p class="text-center fsc-14">
                    {{ dataLang['reg_contract_modal_26'] }}
                </p>
                <div class="mb-10 d-flex wp-100">
                    <div class="wp-50 d-flex py-10" :class="{ 'bg-confirmation': damageCheckbox.no }">
                        <BaseCheckboxV2 placeholder="" class="m-auto" boxClass="bg-white" input-name="no"
                            v-model="damageCheckbox.no" @oncheckeds="updateDamageCheckbox">
                            <span :class="damageCheckbox.no ? 'text-white' : 'text-dark'">{{
                                dataLang['reg_contract_modal_27']
                                }}</span>
                        </BaseCheckboxV2>
                    </div>
                    <div class="wp-50 d-flex py-10" :class="{ 'bg-danger': damageCheckbox.yes }">
                        <BaseCheckboxV2 placeholder="" class="m-auto" boxClass="bg-white" input-name="yes"
                            v-model="damageCheckbox.yes" @oncheckeds="updateDamageCheckbox">
                            <span :class="damageCheckbox.yes ? 'text-white' : 'text-dark'">{{
                                dataLang['reg_contract_modal_28']
                                }}</span>
                        </BaseCheckboxV2>
                    </div>
                </div>
                <p class="text-center fsc-14 mb-25">
                    {{ dataLang['reg_contract_modal_29'] }}
                </p>
                <div class="mb-25">
                    <BaseStarRating :value="starRating" @updateNum="updateStarRating" />
                </div>
                <BaseTextarea placeholder="Комментарий к оценке клиента" class="wp-100 fsc-14 mb-10"
                    input-name="comment" @onInput="({ value }) => comment = value" :minHeight="'140'"
                    inputClass="fsc-14" name-sign="" :value="comment">
                </BaseTextarea>
                <div class="wp-100 fsc-14">
                    {{ dataLang['reg_contract_modal_31'] }}
                </div>
                <div class="d-flex justify-content-end gap-30 mt-15 pb-10">
                    <div @click="saveDate"
                        class="btn btn-sm py-5 btn-primary action-hover px-15 rounded-5 d-flex align-items-center justify-content-center text-uppercase">
                        ПОДТВЕРЖДАЮ.ОБЪЕКТ ПРИНЯТ
                    </div>
                </div>
            </div>
        </div>
    </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import GeneralService from '@/api/GeneralService.js'
import EventBus from '@/event-bus'

export default {
    components: {
    },
    data() {
        return {
            localLoading: false,
            contractId: null,
            dateTime: null,
            damageCheckbox: {
                yes: false,
                no: true
            },
            isDamage: false,
            comment: null,
            starRating: 0
        }
    },
    methods: {
        notAfterToday(date) {
            return date > new Date()
        },
        updateDamageCheckbox(data) {
            if (data.name == 'yes') {
                this.isDamage = true
                this.damageCheckbox.yes = true
                this.damageCheckbox.no = false
            } else {
                this.isDamage = false
                this.damageCheckbox.yes = false
                this.damageCheckbox.no = true
            }
            console.log(this.damageCheckbox, data);

        },
        updateStarRating(data) {
            this.starRating = data
        },
        openModal(openedParams) {
            this.contractId = openedParams.params.contracts__id
            if (openedParams.params.additionalDate) {
                this.dateTime = new Date(openedParams.params.additionalDate.slice(0, -3))
            }
        },
        closeModal() {
            this.dateTime = null
            this.isDamage = false
            this.comment = null
            this.starRating = 0
        },
        saveDate() {
            if (this.dateTime && this.starRating > 0) {
                this.localLoading = true
                GeneralService.edit(`/contracts/${this.contractId}/confirm/in`, {
                    contracts__ends: this.$time(this.dateTime).format('YYYY-MM-DD HH:mm:ss'),
                    "rayting": this.starRating,
                    "comment": this.comment,
                    "isDamage": this.isDamage
                })
                    .then(async (data) => {
                        this.$toast.success(data.data.message)
                        this.$emit('update', { close: true })
                        this.$modal.hide('confirmedIssueCarReturn')
                    })
                    .catch((e) => {
                        console.error(e)
                        if (e?.response?.data?.message) {
                            this.$emit('error', e.response.data.errors)
                            this.$toast.error(e?.response?.data?.message, { duration: 5000 })
                            this.$modal.hide('confirmedIssueCarReturn')
                        }
                    }).finally(() => {
                        this.localLoading = false
                    })
            } else {
                this.$toast.error('Заполните дату и рейтинг', { duration: 5000 })
            }
        },
    },
    mounted() { },
    created() { },
    beforeDestroy() { },

    computed: {
        ...mapState('translationModule', ['dataLang']),
        ...mapState('userSettingModule', ['userSetting'])
    }
}
</script>
